import { Sparkles } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

// Section 13 — AI-assisted management support. Strictly decision support on
// authorised platform data; never a safety professional or decision-maker.
export const ForeseeAi = ({ sp }) => (
  <section aria-labelledby="foresee-ai-heading" data-testid="foresee-ai" className="relative overflow-hidden bg-navy-900 py-20 sm:py-28">
    <div className="grain-overlay" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="13"
        eyebrow="Assisted Insight"
        title="Help authorised users make sense of live platform information"
        description={sp.aiCopy}
        dark
        testid="foresee-ai-header"
      />
      <div className="mx-auto mt-12 max-w-3xl">
        <Reveal>
          <div className="rounded-xl border border-white/10 bg-white/5 p-7 sm:p-8">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-indigo-500 text-white">
              <Sparkles className="h-5 w-5" aria-hidden="true" />
            </span>
            <p className="mt-4 text-sm font-semibold text-slate-300">Authorised users can ask questions such as:</p>
            <ul className="mt-4 space-y-2.5">
              {(sp.aiExamples || []).map((q) => (
                <li key={q} className="rounded-lg border border-white/10 bg-white/5 px-4 py-2.5 text-sm font-semibold text-slate-100">
                  “{q}”
                </li>
              ))}
            </ul>
            <p className="mt-6 text-xs leading-relaxed text-slate-400">
              The assistant provides decision support grounded in information the signed-in user is authorised to access within Foresee. It does not make compliance decisions, is not a safety professional and does not replace competent professional judgement.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
